import React from 'react';
import {Suggestions} from 'components';

export function NegativeBeliefs(props) {
  return (
    <Suggestions.List {...props}>
      <p>I am lazy</p>
      <p>I am not smart enough</p>
      <p>I will never be successful</p>
      <p>I always fail</p>
      <p>nobody would want me</p>
      <p>I am too fat</p>
      <p>I am not good enough</p>
      <p>I have bad luck</p>
      <p>I am stupid</p>
      <p>I am falling behind</p>
      <p>I always make the wrong decision</p>
      <p>I follow the wrong people</p>
      <p>I am too old to …</p>
      <p>I am a loser</p>
    </Suggestions.List>
  );
}
